import React from 'react';
import DialsSection from '../components/home/DialsSection';
import RecommendationsCard from '../components/supplements/RecommendationsCard';

// "You" — the flagship. Your measured self across time, per metric, with the
// trajectory chart and the reachable Next / target readouts. (The forecasting +
// self-grading machinery still runs under the hood, just not surfaced here.)

const YouPage = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-2 pb-10">
      <DialsSection />
      <div className="mt-8">
        <RecommendationsCard title="Supplement suggestions" showGoalPicker />
      </div>
    </div>
  );
};

export default YouPage;
